import _ from 'lodash';
import IAxisTitle from '../../abs/views/market/Summary/entities/IAxisTitle';
import { PNGChartHeight } from './utils';

class Extensions {
  // 取得放大chart配置信息
  getEnLargeConfig = (config: any) => {
    if (config && config.title && config.title.text === null) {
      // 饼图显示标题
      _.set(config, 'title.text', config.chartData.title);
    }
    return config;
  }

  // 旧复杂作图数据下载（准备废弃）
  getChartDownloadData(chartData: any, axisTitle: IAxisTitle) {
    let yColoumName: string[] = [];
    if (axisTitle && axisTitle.y) {
      axisTitle.y.map(item => {
        if (item) {
          const index = item.indexOf('（');
          if (index > -1) {
            item = item.substring(0, index);
          }
          yColoumName.push(item);
        }
      });
    }
    return {
      data_str: JSON.stringify(chartData),
      x_str: axisTitle && axisTitle.x ? axisTitle.x : '',
      y_str: yColoumName.length > 1 ? yColoumName.join('/') : yColoumName.join('')
    };
  }
  // 新简单作图数据
  getSimpleChartDownloadData(downloadList: any, title: any, xAxis: any, yAxis: any) {
    const yAxis1 = typeof yAxis === 'object' ? yAxis : yAxis[0];
    const data = {
      x_str: xAxis && xAxis.title && xAxis.title.text ? xAxis.title.text : '',
      y_str: yAxis1 && yAxis1.title && yAxis1.title.noFormatText ? yAxis1.title.noFormatText : '',
      simple_xy_data: {
        title: title.text,
        data: downloadList
      }
    };
    return data;
  }

  // 图片下载前的-样式与title处理
  getSVGConfig = (config: any, isBgWhite: boolean, type?: 'chart' | 'stock' | 'map') => {
    if (!config) {
      return null;
    }
    let newConfig = _.cloneDeep(config);
    // 内容处理
    // y轴标题 处理
    const { axisTitle, yAxis, isNew, chart } = newConfig;
    if (chart) {
      chart.height = PNGChartHeight;
    }
    let yAxisTitle1 = '';
    let yAxisTitle2 = '';
    if (isNew) {
      if (yAxis && yAxis.length > 1) {
        yAxisTitle1 = yAxis && yAxis[0] ? yAxis[0].title.noFormatText : '';
        yAxisTitle2 = yAxis && yAxis[1] ? yAxis[1].title.noFormatText : '';
      } else {
        yAxisTitle1 = yAxis ? yAxis.title.noFormatText : '';
      }
    } else {
      yAxisTitle1 = axisTitle ? axisTitle.y[0] : '';
      yAxisTitle2 = axisTitle ? axisTitle.y[1] : '';
    }
    if (yAxis && yAxis.length > 1) {
      _.set(newConfig, 'yAxis[0].title.text', yAxisTitle1);
      _.set(newConfig, 'yAxis[1].title.text', yAxisTitle2);
    } else {
      _.set(newConfig, 'yAxis.title.text', yAxisTitle1);
    }

    // 饼图显示标题
    const { title } = newConfig;
    if (title && title.text === null) {
      _.set(newConfig, 'title.text', newConfig.chartData.title);
    }
    
    // 纯样式处理
    let basicColor = { color: '#FFF' };
    if (isBgWhite) {
      basicColor = { color: '#000' };
      _.set(newConfig, 'chart.backgroundColor', '#FFF');
      _.set(newConfig, 'title.style', basicColor);
      _.set(newConfig, 'legend.itemStyle', basicColor);
      _.set(newConfig, 'legend.navigation.style', basicColor);

      if (type === 'stock') {
        _.set(newConfig, 'rangeSelector.inputStyle', basicColor);
        _.set(newConfig, 'rangeSelector.labelStyle', basicColor);
      }
    }
    if (type === 'stock') {
      _.set(newConfig, 'rangeSelector.buttons', []);
      _.set(newConfig, 'rangeSelector.inputBoxHeight', 12);
      const { series } = newConfig;
      for (let i = 0; i < series.length; i++) {
        if (series[i].type === 'area') {
          _.set(newConfig, `series[${i}].fillColor`, null);
        }
      }
    }
    _.set(newConfig, 'xAxis.title.style', basicColor);
    _.set(newConfig, 'xAxis.labels.style', basicColor);

    if (yAxis && yAxis.length > 1) {
      _.set(newConfig, 'yAxis[0].title.style', basicColor);
      _.set(newConfig, 'yAxis[1].title.style', basicColor);
      _.set(newConfig, 'yAxis[0].labels.style', basicColor);
      _.set(newConfig, 'yAxis[1].labels.style', basicColor);
    } else {
      _.set(newConfig, 'yAxis.title.style', basicColor);
      _.set(newConfig, 'yAxis.labels.style', basicColor);
    }

    // 白底与黑底共同样式处理
    _.set(newConfig, 'legend.maxHeight', 300);
    _.set(newConfig, 'title.style.letterSpacing', 0);

    return newConfig;
  }
}

export default new Extensions();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/extensions.ts